import * as React from "react";

export interface GuidanceIconProps {
  className?: string;
}

export const GuidanceIcon: React.FC<GuidanceIconProps> = ({ className }) => {
  return (
    <svg
      width="76"
      height="76"
      viewBox="0 0 76 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="76" height="76" fill="#00AEEF" />
      <rect
        x="54.9277"
        y="34.8847"
        width="11.4819"
        height="1.64027"
        rx="0.820137"
        fill="#FFDB66"
      />
      <rect
        x="9"
        y="34.8847"
        width="11.4819"
        height="1.64027"
        rx="0.820137"
        fill="#FFDB66"
      />
      <rect
        x="36.8847"
        y="18.4819"
        width="11.4819"
        height="1.64027"
        rx="0.820137"
        transform="rotate(-90 36.8847 18.4819)"
        fill="#FFDB66"
      />
      <rect
        x="36.8847"
        y="64.4096"
        width="11.4819"
        height="1.64027"
        rx="0.820137"
        transform="rotate(-90 36.8847 64.4096)"
        fill="#FFDB66"
      />
      <rect
        x="52.8752"
        y="43.9062"
        width="11.4819"
        height="1.64027"
        rx="0.820137"
        transform="rotate(30 52.8752 43.9062)"
        fill="#FFDB66"
      />
      <rect
        x="13.1006"
        y="20.9423"
        width="11.4819"
        height="1.64027"
        rx="0.820137"
        transform="rotate(30 13.1006 20.9423)"
        fill="#FFDB66"
      />
      <rect
        x="23.3546"
        y="45.5464"
        width="11.4819"
        height="1.64027"
        rx="0.820137"
        transform="rotate(150 23.3546 45.5464)"
        fill="#FFDB66"
      />
      <rect
        x="63.1291"
        y="22.5826"
        width="11.4819"
        height="1.64027"
        rx="0.820137"
        transform="rotate(150 63.1291 22.5826)"
        fill="#FFDB66"
      />
      <rect
        x="53.2137"
        y="11.2899"
        width="11.4819"
        height="1.64027"
        rx="0.820137"
        transform="rotate(120 53.2137 11.2899)"
        fill="#FFDB66"
      />
      <rect
        x="24.5826"
        y="10.2805"
        width="11.4819"
        height="1.64027"
        rx="0.820137"
        transform="rotate(60 24.5826 10.2805)"
        fill="#FFDB66"
      />
      <path
        d="M38.125 20.5C46.7332 20.5114 53.7081 27.4935 53.708 36.1045C53.7079 41.8172 50.6366 46.8111 46.0586 49.5293C45.409 49.915 45.0098 50.6067 45.0098 51.3545V55.7842L44.3164 55.4941C44.2301 55.4581 44.1354 55.4385 44.0352 55.4385H32.1729C32.0724 55.4385 31.9771 55.458 31.8906 55.4941L31.1982 55.7842V51.3545C31.1982 50.6102 30.81 49.9207 30.1758 49.5459C25.5828 46.8315 22.5002 41.8284 22.5 36.1045C22.4999 27.4945 29.515 20.4888 38.125 20.5Z"
        fill="#FFDB66"
        stroke="#003E6B"
      />
      <path
        d="M35.69 51.3544C35.69 50.4371 35.2121 49.5817 34.4223 49.115C29.9751 46.4866 26.992 41.6441 26.9919 36.1042C26.9918 28.4527 32.7164 22.1106 40.1037 21.1318C39.4558 21.0461 38.7952 21.001 38.1241 21C29.7905 20.9891 22.9999 27.7704 23 36.1042C23.0001 41.6441 25.9832 46.4867 30.4304 49.115C31.2202 49.5817 31.6981 50.4371 31.6981 51.3544V55.0333C31.8443 54.9722 32.0047 54.9382 32.173 54.9382H35.69V51.3544Z"
        fill="#FEC458"
      />
      <path
        d="M39.9958 55.6626C39.5958 55.6626 39.2715 55.3383 39.2715 54.9383V48.4558C39.2715 47.8043 39.4909 47.1617 39.889 46.6461L40.9255 45.3041C41.1289 45.0408 41.2409 44.7127 41.2409 44.3799V37.6149C41.2409 37.2149 41.5652 36.8906 41.9652 36.8906C42.3652 36.8906 42.6895 37.2149 42.6895 37.6149V44.3799C42.6895 45.0314 42.4701 45.6741 42.072 46.1897L41.0355 47.5316C40.832 47.795 40.7201 48.1231 40.7201 48.4558V54.9383C40.7201 55.3383 40.3958 55.6626 39.9958 55.6626Z"
        fill="#003E6B"
      />
      <path
        d="M36.2122 55.6626C35.8122 55.6626 35.4879 55.3383 35.4879 54.9383V48.4558C35.4879 48.1232 35.3758 47.795 35.1725 47.5316L34.1359 46.1897C33.7377 45.6742 33.5184 45.0314 33.5184 44.3799V37.6149C33.5184 37.2149 33.8427 36.8906 34.2427 36.8906C34.6427 36.8906 34.967 37.2149 34.967 37.6149V44.3799C34.967 44.7127 35.079 45.0408 35.2824 45.304L36.319 46.646C36.7172 47.1616 36.9365 47.8043 36.9365 48.4557V54.9382C36.9365 55.3383 36.6122 55.6626 36.2122 55.6626Z"
        fill="#003E6B"
      />
      <path
        d="M48.6404 33.1466C47.8566 30.2257 45.8428 27.7833 43.1154 26.4459C42.7563 26.2698 42.6079 25.8358 42.7839 25.4768C42.96 25.1176 43.3942 24.9693 43.7531 25.1453C46.856 26.6667 49.1473 29.4463 50.0395 32.7712C50.1432 33.1575 49.914 33.5548 49.5277 33.6585C49.1416 33.7622 48.7441 33.5333 48.6404 33.1466Z"
        fill="#FFEAC8"
      />
      <path
        d="M42.6892 39.1426H33.5187C33.1187 39.1426 32.7944 38.8183 32.7944 38.4183C32.7944 38.0183 33.1187 37.694 33.5187 37.694H42.6892C43.0892 37.694 43.4135 38.0183 43.4135 38.4183C43.4135 38.8183 43.0892 39.1426 42.6892 39.1426Z"
        fill="#003E6B"
      />
      <path
        d="M41.5285 65.0443V66.0746C41.5285 67.9595 39.9886 69.5003 38.1037 69.5003C36.2189 69.5002 34.6789 67.9594 34.6789 66.0746V65.0443H41.5285Z"
        fill="#CCCCCC"
        stroke="#003E6B"
      />
      <path
        d="M37.7973 66.0749V65.5443H35.1789V66.0749C35.1789 67.6837 36.4951 69 38.1039 69C38.5739 69 39.0185 68.887 39.4131 68.6878C38.4572 68.2053 37.7973 67.2137 37.7973 66.0749Z"
        fill="#BBBBBB"
      />
      <path
        d="M43.0698 61.4848C44.0389 61.4848 44.8266 62.2725 44.8266 63.2416V64.3119C44.8264 65.2809 44.0388 66.0688 43.0698 66.0688H33.1381C32.1691 66.0687 31.3815 65.2809 31.3813 64.3119V63.2416C31.3813 62.2725 32.1689 61.4848 33.1381 61.4848H43.0698Z"
        fill="#EEEEEE"
        stroke="#003E6B"
      />
      <path
        d="M43.0697 63.7766H33.1382C32.5706 63.7766 32.0903 63.3983 31.9347 62.8808C31.9003 62.9952 31.8813 63.1163 31.8813 63.2417V64.3116C31.8813 65.0046 32.4451 65.5684 33.1382 65.5684H43.0698C43.7628 65.5684 44.3266 65.0046 44.3266 64.3116V63.2417C44.3266 63.1162 44.3076 62.9951 44.2732 62.8808C44.1176 63.3983 43.6372 63.7766 43.0697 63.7766Z"
        fill="#CCCCCC"
      />
      <path
        d="M44.0352 57.9495C45.0043 57.9496 45.792 58.7372 45.792 59.7063V60.7766C45.7917 61.7456 45.0041 62.5333 44.0352 62.5334H32.1729C31.2038 62.5334 30.4163 61.7456 30.416 60.7766V59.7063C30.416 58.7372 31.2037 57.9495 32.1729 57.9495H44.0352Z"
        fill="#EEEEEE"
        stroke="#003E6B"
      />
      <path
        d="M44.035 60.2413H32.1729C31.6054 60.2413 31.125 59.8629 30.9695 59.3453C30.935 59.4598 30.916 59.5808 30.916 59.7063V60.7762C30.916 61.4692 31.4798 62.0331 32.1728 62.0331H44.0349C44.728 62.0331 45.2918 61.4692 45.2918 60.7762V59.7063C45.2918 59.5808 45.2728 59.4598 45.2384 59.3453C45.0829 59.8629 44.6026 60.2413 44.035 60.2413Z"
        fill="#CCCCCC"
      />
      <path
        d="M44.0352 54.4141C45.0043 54.4142 45.792 55.2018 45.792 56.1709V57.2412C45.7918 58.2101 45.0041 58.9979 44.0352 58.998H32.1729C31.2038 58.998 30.4162 58.2102 30.416 57.2412V56.1709C30.4161 55.2017 31.2037 54.4141 32.1729 54.4141H44.0352Z"
        fill="#EEEEEE"
        stroke="#003E6B"
      />
      <path
        d="M44.035 56.7059H32.1729C31.6054 56.7059 31.125 56.3275 30.9695 55.81C30.935 55.9245 30.916 56.0455 30.916 56.171V57.2408C30.916 57.9338 31.4798 58.4977 32.1728 58.4977H44.0349C44.728 58.4977 45.2918 57.9338 45.2918 57.2408V56.171C45.2918 56.0454 45.2728 55.9244 45.2384 55.81C45.0829 56.3275 44.6026 56.7059 44.035 56.7059Z"
        fill="#CCCCCC"
      />
    </svg>
  );
};
